import { render, staticRenderFns } from "./PbElementForm.vue?vue&type=template&id=6b1e468b&"
import script from "./PbElementForm.vue?vue&type=script&lang=js&"
export * from "./PbElementForm.vue?vue&type=script&lang=js&"
import style0 from "./PbElementForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports